import { Text, TextAppearance } from '@volkswagen-onehub/components-core';
import Axios, { AxiosResponse } from 'axios';
import React, { useEffect } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { dpsSend } from 'src/bff';
import { FormController, useOneFormContext, formatPrefix } from 'src/feature-app';
import { getParamsForm } from 'src/feature-app/get-params-form';
import { FormDataGroup, FormInfo, MolecularResponse, OneFormState, Steps } from 'src/types';
import { BonoClienteFields, ThankYouMGM } from './';
import { LegalMGM } from './LegalMGM';
import { MGMFormProps } from './MGMController';
import { formatHeaders, formDataBuilder } from '../format-fields';
import { MGMLayout } from './MGMLayout';

const bonoClienteCopies = {
  title: 'Solo te queda un Sí, para tener hasta 1.000€.',
  copy: '¡Comprueba tus datos y envía!',
};

export function BonoClienteForm(props: MGMFormProps) {
  const { dpsData, idLead, idPerson, trackFormLoad } = props;
  const { initializeForm } = useOneFormContext();
  const store = useStore();
  const dispatch = useDispatch();
  const steps: Steps[] = [
    {
      title: <></>, // El title se renderiza en los fields al ser un form de un solo step con un diseño que incluye un stage.
      fields: (
        <MGMLayout
          title={bonoClienteCopies.title}
          fields={<BonoClienteFields title={bonoClienteCopies.title} copy={bonoClienteCopies.copy} />}
        />
      ),
      screenIndex: 0,
      name: 'Form',
    },
  ];

  const BonoClienteData: Partial<FormDataGroup> = {
    headers: {
      DESC_BRAND: 'VW',
      DESC_GDPR_ADAPTED: 'true',
      DESC_CAMPAIGNBLOCK: '16. One shot',
      DESC_ID_CAMPAIGN: '7011n000001FY4sAAG',
      DESC_TOKEN: 'VW_DDB_FRM_MGM_CLIENTE_RENOVACION_STOCK_22',
      DESC_FORM_DETAIL: 'MGM Bono Cliente Renovación Stock 22',
    },
    fields: {
      formName: 'mgm-bono-cliente',
      formType: 'otherform',
      pageCategory: 'Cupon',
      name: idPerson.FirstName,
      surname: idPerson.LastName,
      secondSurname: idPerson.TXT_2_Surname__c,
      email: idPerson.TXT_Email__c,
      cellphone: idPerson.NUM_Phone_mobile__c,
    }, // Analítica
  };

  const generateData = () => {
    const { formData }: OneFormState = store.getState();
    const { fields, headers } = formData;
    const { tc, today, url, device } = getParamsForm();

    return {
      'headers[COD_FORM_ID]': `vw-oneform-${fields.formName}`,
      'headers[DESC_DEVICETYPE]': device,
      'headers[DESC_FORMOBJECTIVE]': fields.pageCategory, // Revisar
      'headers[DESC_URLORIGIN]': url,
      'headers[FECHA_INSERTION_DATE]': today,
      'headers[TC]': tc,
      'headers[PINCODE]': dpsData?.pincode?.pincodeResponse?.params?.pincode,
      ...formatHeaders(headers), // Headers comunes a todos los formularios de leads

      'fields[DESC_SURNAME_2]': fields.secondSurname,
      'fields[DESC_SURNAME_1]': fields.surname,
      'fields[DESC_NAME]': fields.name,
      'fields[DESC_EMAIL_ADDRESS]': fields.email,
      'fields[NUM_CELLPHONE]': `${formatPrefix(fields.prefix)}${fields.cellphone}`,
      'fields[DESC_FORM_VERSION]': `vw-oneform-${fields.formName}-${process.env.VERSION}`,
      'fields[DESC_AUXFIELD20]': idPerson.Id,
      'fields[DESC_AUXFIELD1]': 'Bono Cliente',
      'fields[DESC_LOPD]': 'PERMITE',
      'fields[DESC_TRANF_DATA_THIRD]': 'NO INFORMADO',
      'fields[DESC_LSSI]': idPerson.LSSI__c,
      'fields[DESC_LOPD_GDPR_PERFILADO]': idPerson.Robinson__c,

      'flags[FLAG_ISLEAD]': 'false',
      'flags[FLAG_ISPROSPECT]': 'true',
      'flags[FLAG_VOUCHER]': 'true',
    };
  };

  const generateSubmitData = () => generateData();

  const sendForm = (): Promise<boolean> => {
    return new Promise<any>(async (resolve) => {
      const data = generateSubmitData();

      const dataStringified = JSON.stringify(data);
      const dataParsed = JSON.parse(dataStringified);
      const formData = formDataBuilder(dataParsed);

      const response = await dpsSend(formData);

      if (response && response.data && response.data.content && response.data.content.code === '200') {
        dispatch({ type: 'SET_FORM_RESPONSE', payload: response.data });
        resolve(true);
      } else {
        resolve(false);
      }
    });
  };

  // const { loading, steps, firstStep, lastStep } = useInitializeMGMForm(steps, idLead);

  useEffect(() => {
    const BonoClienteInfo: Partial<FormInfo> = {
      formStarted: true,
      sendFormCallback: sendForm,
      fullScreen: steps[0].fullScreen ? true : false,
      lastStep: steps[steps.length - 1],
      numberOfScreens: steps.length,
      screenIndex: steps[0].screenIndex,
      hideLegal: true,
      formTheme: 'main',
      notALayer: true,
      formType: 'inPage',
      step: steps[0],
      steps,
      stepsHistory: [0],
      customLegal: <LegalMGM />,
      thankYouComponent: <ThankYouMGM />,
    };
    initializeForm(BonoClienteInfo, BonoClienteData, true);
    trackFormLoad();
  }, []);

  return !steps ? null : <FormController steps={steps} screenType="full-screen" />;
}
